import {queryOptions, useQuery} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

type GeneratePickingListBody = sdk.PostPickingListDistributeOrdersData['body']

export type GeneratePickingListResponse = sdk.PostPickingListDistributeOrdersResponse

export function distributedBatchesListQueryOptions(body?: GeneratePickingListBody) {
  return queryOptions({
    queryKey: ['distributed-batches-list', body],
    queryFn: async () => {
      const {data} = await sdk.postPickingListDistributeOrders({body})
      return data || null
    },
  })
}

export function useDistributedBatchesList(body?: GeneratePickingListBody) {
  const {data, ...rest} = useQuery(distributedBatchesListQueryOptions(body))
  return {...rest, distributedBatchesList: data}
}
